import './App.css';
import React from 'react';
import NewAuth from "./components/authorization/Auth";
const App = () => {
    // Игнорировать ошибку ResizeObserver
    const resizeObserverErr = () => {
        const originalError = console.error;
        console.error = (...args) => {
            if (/ResizeObserver/.test(args[0])) {
                return;
            }
            originalError.apply(console, args);
        };
    };
    resizeObserverErr();
    return <NewAuth />
};

export default App;
